import { render } from "./FormularioMatricula.vue?vue&type=template&id=77b83bde&scoped=true"
import script from "./FormularioMatricula.vue?vue&type=script&lang=js"
export * from "./FormularioMatricula.vue?vue&type=script&lang=js"

import "./FormularioMatricula.vue?vue&type=style&index=0&id=77b83bde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b83bde"]])

export default __exports__